
class CollectionTab extends HTMLElement {
  constructor() {
    super();
    const tabs = this.querySelectorAll(".tab-btn");
    const panels = this.querySelectorAll(".tab-panel");

    tabs.forEach(tab => {
      tab.addEventListener("click", () => {
        tabs.forEach(btn => btn.classList.remove("active"));
        tab.classList.add("active");
        let target = tab.getAttribute("data-tab");
        panels.forEach(panel => {
          panel.classList.remove("active");
        });
        const activePanel = this.querySelector("#" + target);
        activePanel.classList.add("active");
        activePanel.animate(
          [
            { opacity: 0 },
            { opacity: 1 }
          ],
          {
            duration: 300,
            easing: "ease"
          }
        );

      });
    });
    var swiper = new Swiper(".js-tabs-carousel", {
      slidesPerView: 1.5,
      spaceBetween: 8,
      breakpoints: {
        769: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4.565,
          spaceBetween: 20,
        }
      }
    });
  }
}

customElements.define('collection-tab', CollectionTab);
